import { simpleSet } from '@r/reducers/utils';

const setCalculationModePullsSearchText = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.pulls.searchText;

export const searchText = setCalculationModePullsSearchText(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_PULLS_SEARCH_TEXT',
  ''
);
